import { Component } from "react";
import "./layout.less";
import "../styles/icons/style.less";
import "../styles/animations.less";
import "../components/block-elements/ui-select/ui-select.less";
import "../components/block-elements/ui-radio/ui-radio.less";
import "../components/block-elements/ui-input/ui-input.less";
import "../components/block-elements/ui-inc-dec-btn/ui-inc-dec-btn.less";
import "../components/block-elements/ui-checkbox/ui-checkbox.less";
import "../styles/theming/page-themes-new.less";
import "../styles/theming/component-themes-new.less";
import "@parksandresorts/core/gronalund.css";

export default class Layout extends Component {
  render() {
    return <div id="Layout">{this.props.children}</div>;
  }
}
